import React, { useEffect, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  collection,
  getDocs,
  getFirestore,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

import { NewUserProfileType } from "../Types/userProfile";
import UserInformation from "./UserInformation";
import { app, auth } from "../lib/firebase";
import "../lib/RequireUser/index.css";

import { getStorage, ref } from "firebase/storage";

const db = getFirestore(app);

var user2: any;
var uid: any;

var bodyStyles = document.body.style;

const tempUser = localStorage.getItem("userUID");
console.log("inside UserProfile 1 and local storage for userID = ", tempUser);
//document.querySelector(':root').style.setProperty("--user"), localStorage.getItem("userUID"));

//const userUID = bodyStyles.getPropertyValue("--user");
//console.log("inside UserProfile 1 and user id from root = ", userUID);

function UserProfile() {
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const q = query(
    collection(db, "userProfiles"),
    where("userUID", "==", tempUser)
  );

  useEffect(
    () =>
      onSnapshot(q, (snapshot) => {
        setUserProfiles(
          snapshot.docs.map((doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  return (
    <div>
      {userProfiles && userProfiles.length ? (
        <div>
          {userProfiles?.map((userProfiles) => (
            <UserInformation key={userProfiles.id} userProfile={userProfiles} />
          ))}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default UserProfile;
